import http from "../utils/http";
import { getKizValidationError } from "../utils/kiz";

const baseFields = {
  "fields[0]": "documentId",
  "fields[1]": "code_raw",
  "fields[2]": "status",
  "fields[3]": "scanned_at",
  "fields[4]": "destroy_kiz",
};

function mapKizCode(raw) {
  const attr = raw.attributes || {};
  return {
    id: raw.id,
    documentId: raw.documentId || attr.documentId,
    code_raw: raw.code_raw || attr.code_raw,
    status: raw.status || attr.status,
    scanned_at: raw.scanned_at || attr.scanned_at,
    destroy_kiz:
      raw.destroy_kiz ?? attr.destroy_kiz ?? raw.destroyKiz ?? attr.destroyKiz,
  };
}

export async function fetchReturnQueue() {
  const res = await http.get("/return-scans", {
    params: {
      ...baseFields,
      "filters[status][$eq]": "queued",
      "sort[0]": "scanned_at:desc",
    },
  });

  return (res.data?.data || []).map(mapKizCode);
}

export async function upsertReturnScan(code) {
  const clean = String(code || "").trim();
  if (!clean) throw new Error("КИЗ пустой");
  const validationError = getKizValidationError(clean);
  if (validationError) throw new Error(validationError);

  const existing = await http.get("/return-scans", {
    params: {
      ...baseFields,
      "filters[code_raw][$eq]": clean,
      "pagination[pageSize]": 1,
    },
  });

  const record = existing.data?.data?.[0];
  const mappedRecord = record ? mapKizCode(record) : null;
  const payload = {
    data: {
      code_raw: clean,
      status: "queued",
      scanned_at: new Date().toISOString(),
      destroy_kiz: mappedRecord?.destroy_kiz ?? false,
    },
  };

  if (record) {
    const docId = record.documentId || record.id;
    await http.put(`/return-scans/${docId}`, payload);
    return mapKizCode(record);
  }

  const created = await http.post("/return-scans", payload);
  const createdRecord = created.data?.data;
  return createdRecord ? mapKizCode(createdRecord) : null;
}

export async function markKizReturned(documentId) {
  if (!documentId) throw new Error("Нет documentId КИЗ");
  return http.put(`/return-scans/${documentId}`, {
    data: { status: "returned" },
  });
}

export async function setReturnScanDestroy(documentId, destroyKiz) {
  if (!documentId) throw new Error("Нет documentId КИЗ");
  return http.put(`/return-scans/${documentId}`, {
    data: { destroy_kiz: !!destroyKiz },
  });
}
